export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center bg-background-50 pt-16">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium text-primary-700 bg-primary-100/80 rounded-full mb-5">
              官方安全入口 · 高清漫画平台
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              51漫画网
              <br className="md:hidden" />
              <span className="text-primary-600"> 安全高清漫画在线阅读官方平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-4">
              漫迷首选 · 每日更新 · 极速畅读
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              51漫画网作为官方安全入口，为广大漫迷提供稳定可靠的在线阅读服务。平台涵盖51漫画网页版与51漫画网址，支持多种设备无缝切换，
              每日同步更新热门漫画资源。无论您使用的是51漫画官网版还是移动端，都能享受到高清画质与流畅翻页的极致阅读体验。
              当前站内汇聚了热血、恋爱、奇幻、悬疑等丰富题材，满足各类读者的阅读偏好，是您开启高清漫画之旅的最佳选择。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">20000+</div>
                <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">同步连载</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">安全直达</div>
                <div className="text-xs text-foreground-500 mt-1">官方认证</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.getElementById('cards');
                  if (el) {
                    const top = el.getBoundingClientRect().top + window.scrollY - 80;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                开始阅读
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#app"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.getElementById('app');
                  if (el) {
                    const top = el.getBoundingClientRect().top + window.scrollY - 80;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="w-full sm:w-auto px-8 py-3 border border-foreground-300 text-foreground-700 font-medium rounded-full text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                移动端入口
                <i className="ri-smartphone-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="aspect-[4/5] w-full rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Vibrant%20manga%20reading%20scene%20with%20colorful%20comic%20panels%20floating%20in%20a%20warm%20atmospheric%20setting%2C%20artistic%20Japanese%20manga%20style%20illustration%20with%20dynamic%20action%20lines%2C%20warm%20orange%20and%20red%20accents%20on%20cream%20background%2C%20eye-catching%20composition%2C%20editorial%20quality%2C%20clean%20and%20modern%20feel&width=800&height=1000&seq=hero-manga-01&orientation=portrait"
                  alt="51漫画网 - 高清漫画在线阅读体验"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 w-24 h-24 md:w-28 md:h-28 rounded-2xl overflow-hidden border-4 border-background-50 bg-background-100 hidden sm:block">
                <img
                  src="https://readdy.ai/api/search-image?query=Closeup%20of%20manga%20page%20with%20detailed%20line%20art%20and%20dramatic%20expressions%2C%20black%20and%20white%20ink%20style%20with%20warm%20tone%20paper%20texture%2C%20Japanese%20comic%20art%2C%20intricate%20hatching%2C%20editorial%20photography&width=400&height=400&seq=hero-manga-02&orientation=squarish"
                  alt="51漫画网 - 精彩漫画内页预览"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -top-4 -right-4 w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden border-4 border-background-50 bg-background-100 hidden sm:block">
                <img
                  src="https://readdy.ai/api/search-image?query=Manga%20character%20portrait%20in%20warm%20vibrant%20colors%2C%20anime%20style%20illustration%20with%20expressive%20eyes%2C%20soft%20gradient%20background%20in%20peach%20and%20cream%20tones%2C%20modern%20Japanese%20comic%20art%2C%20clean%20lines%2C%20editorial%20quality&width=400&height=400&seq=hero-manga-03&orientation=squarish"
                  alt="51漫画网 - 人气漫画角色"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}